import validator from "validator";

export function validateFatherName(event, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="") {
      msg="Enter father name";
      reference.current.focus();
      event.preventDefault();
    } else if(!validator.isAlpha(stateobject.trim()) ) {
        msg="Enter valid father name";
      reference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateCity(event, title, reference, stateobject){
    var msg = "";
    if(stateobject.trim()==="") {
      msg="Enter "+title;
      reference.current.focus();
      event.preventDefault();
    } else if (stateobject.trim().length<4  ) {
      msg="Enter valid "+title;
      reference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateDouble(event, title, reference, stateobject, min, max){
    var msg = "";
    if(stateobject.trim()==="") {
      msg="Enter "+title;
      reference.current.focus();
      event.preventDefault();
    } else if(!validator.isDecimal(stateobject.trim())) {
        msg="Enter valid "+title;
      reference.current.focus();
      event.preventDefault();
    } else if(Number(stateobject.trim())<min || Number(stateobject.trim())>max) {
        msg="Enter "+title+" value in between "+min+" and "+max;
      reference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateName(event, firstreference, firststateobject, lastreference, laststateobject){
    var msg = "";
    if(firststateobject.trim()==="") {
      msg="Enter first name";
      firstreference.current.focus();
      event.preventDefault();
    } else if(!validator.isAlpha(firststateobject.trim()) ) {
      msg="Enter valid first name";
      firstreference.current.focus();
      event.preventDefault();
    } else if(laststateobject!==null && laststateobject.trim()!=="" && !validator.isAlpha(laststateobject.trim()) ) {
        msg="Enter valid last name";
        lastreference.current.focus();
        event.preventDefault();
    }  
    return msg;
}

export function validateQuickName(event, firstreference, firststateobject, title){
    var msg = "";
    if(firststateobject!==null && firststateobject.trim()!=="" && !validator.isAlpha(firststateobject.trim()) ) {
        msg="Enter valid "+title;
        firstreference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateMandatoryName(event, firstreference, firststateobject, title){
    var msg = "";
    const regex = /^[A-Za-z0-9\s]*$/;
    if(firststateobject===null || firststateobject.trim()==="") {
      msg="Please enter "+title;
      firstreference.current.focus();
      event.preventDefault();
    } else if(!regex.test(firststateobject.trim()) ) {
        msg="Enter valid "+title;
        firstreference.current.focus();
        event.preventDefault();
    }  
    return msg;
}

export function validateMandatoryValue(event, firstreference, firststateobject, title){
    var msg = "";
    if(firststateobject===null || firststateobject.trim()==="") {
      msg="Please enter "+title;
      firstreference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateEmail(event, reference, stateobject){
    var msg = "";
    if(stateobject===undefined || stateobject===null || stateobject.trim()==="") {
      msg="Enter email address";
      reference.current.focus();
      event.preventDefault();
    } else if (stateobject.trim().length<9 || !validator.isEmail(stateobject.trim()) ) {
      msg="Enter valid email address";
      reference.current.focus();
      event.preventDefault();
    }
    return msg;
}

export function validateMobile(event, reference, stateobject){
    var msg = "";
    if(stateobject===undefined || stateobject===null || stateobject.trim()==="" ) {
        msg="Enter mobile number";
        reference.current.focus();
        event.preventDefault();
    } else if(!validator.isInt(stateobject.trim()) || stateobject.trim().length<10 
            || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
        msg="Enter valid mobile number";
        reference.current.focus();
        event.preventDefault();
    }
    return msg;
}

export function validateAddress(event, reference, stateobject){
  var msg = "";
  if(stateobject===undefined || stateobject===null || stateobject.trim()==="") {
    msg="Enter address";
    reference.current.focus();
    event.preventDefault();
  } else if (stateobject.trim().length<20  ) {
    msg="Enter valid address";
    reference.current.focus();
    event.preventDefault();
  }
  return msg;
}

export function validatePin(event, reference, stateobject){
  var msg = "";
  if(stateobject.trim()==="" ) {
      msg="Enter pin";
      reference.current.focus();
      event.preventDefault();
  } else if(!validator.isInt(stateobject.trim()) || stateobject.length<6
      || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
      msg="Enter valid pin.";
      reference.current.focus();
      event.preventDefault();
  }
  return msg;
}

export function validatePassword(event, reference, stateobject){
  var msg = "";
  if(stateobject.trim()==="" ) {
      msg="Enter password";
      reference.current.focus();
      event.preventDefault();
  } else if(!validator.isStrongPassword(stateobject.trim()) ) {
      msg="Enter valid password";
      reference.current.focus();
      event.preventDefault();
  }
  return msg;
}

export function validateConfirmPassword(event, reference, stateobject, confirmreference, confirmstateobject){
  var msg = "";
  if(stateobject===null || stateobject.trim()==="" ) {
      msg="Enter password";
      reference.current.focus();
      event.preventDefault();
  } else if(!validator.isStrongPassword(stateobject.trim()) ) {
      msg="Enter valid password. min: 8, max:20, required: 1 char, 1 digit, 1 cap, 1 special char";
      reference.current.focus();
      event.preventDefault();
  } else if(confirmstateobject===null || confirmstateobject.trim()==="") {
      msg="Enter confirm password";
      confirmreference.current.focus();
      event.preventDefault();
  } else if(confirmstateobject.trim()!==stateobject.trim()) {
      msg="New password and confirm password does not match";
      confirmreference.current.focus();
      event.preventDefault();
  }
  return msg;
}

export function validateConfirmPin(event, reference, stateobject, confirmreference, confirmstateobject){
  var msg = "";
  if(stateobject===null || stateobject.trim()==="" ) {
      msg="Enter pin";
      reference.current.focus();
      event.preventDefault();
  } else if(!validator.isInt(stateobject.trim()) || stateobject.length<6
      || stateobject.trim().indexOf('-')!==-1 || stateobject.trim().indexOf('+')!==-1) {
      msg="Enter valid pin. min: 6 digit, max: 15 digit";
      reference.current.focus();
      event.preventDefault();
  }
  else if(confirmstateobject===null || confirmstateobject.trim()==="") {
      msg="Enter confirm pin";
      confirmreference.current.focus();
      event.preventDefault();
  } else if(confirmstateobject.trim()!==stateobject.trim()) {
      msg="New pin and confirm pin does not match";
      confirmreference.current.focus();
      event.preventDefault();
  }
  return msg;
}
